// Myst Music — unified studio campus site.
// Real content merged from the two source sites (Highgate + Neon).

export const BRAND = {
  name: "Myst Music",
  logo: "https://image.static.bstage.in/cdn-cgi/image/metadata=none/mystmusic/99331767-9d7a-4713-aade-8775bb83b778/b8e30dad-bf73-4f81-81b3-10b7018a7fc7/ori.png",
  email: "info@mystmusic.io",
  address: "1840 S Sepulveda Blvd · Los Angeles 90025",
  venueName: "The Tuscan LA",
  venueUrl: "https://www.thetuscanla.com",
};

export const NAV_LINKS = [
  { label: "Studios", target: "studios" },
  { label: "Artists", target: "artists" },
  { label: "Spaces", target: "spaces" },
  { label: "Events", target: "events" },
];

const CDN = "https://images.squarespace-cdn.com/content/v1/674d19173c99f218d8c28125";

export const REEL_IMAGES = [
  `${CDN}/87a19a28-14d8-4cec-892c-cf465b0f0768/Myst+Studios-44-min.jpg?format=800w`,
  `${CDN}/786bd8ec-5d29-4a59-a30c-28006d8dbeb1/Myst+Studio+A+2-min.jpg?format=800w`,
  `${CDN}/5f50b412-77a3-4330-9d26-c1f5803c0118/Myst+Studios-20-min.jpg?format=800w`,
  `${CDN}/a531be3e-b0a0-4d7b-abf3-e41a4d45fd9c/Myst+Studios-33-min.jpg?format=800w`,
  `${CDN}/43bf66fa-408e-4962-8bf3-2ec4d04f9303/Myst+Studios-39-min.jpg?format=800w`,
  `${CDN}/0843e184-26df-4723-a3bb-fc6ee22b0ddd/Myst+Studios-17-min.jpg?format=800w`,
  `${CDN}/80d20269-defb-42ef-8dfa-697ab209e192/Myst+Studios-14-min.jpg?format=800w`,
  `${CDN}/2fe65be7-a50d-4f81-8aa0-d9d81fce34a9/Myst+Studios-45-min.jpg?format=800w`,
];

export const REEL_IMAGES_2 = [
  `${CDN}/2a7ea994-184e-4870-bf3d-0daa3f413485/Myst+Studios-25-min.jpg?format=800w`,
  `${CDN}/8cf985cc-d206-4b62-8bbf-9c7e3ca843ab/Myst+Bar+2-min.jpg?format=800w`,
  `${CDN}/c1adc7a4-a628-4a2e-afc2-22a3ece816c1/Myst+Yard+2-min.jpg?format=800w`,
  `${CDN}/303c9f37-b403-4f78-8242-09841666f648/Myst+Studios-18-min.jpg?format=800w`,
  `${CDN}/451a661b-0bd7-40d2-81e2-96cfed6827fd/Myst+Studios-15-min.jpg?format=800w`,
  `${CDN}/99ed1fcc-a7ba-473f-918a-111fc9ed74fc/Myst+Studios-42-min.jpg?format=800w`,
  `${CDN}/ced6b079-9da8-4ae3-a331-0a0d89aed9e4/Myst+Studios-13-min.jpg?format=800w`,
  `${CDN}/bb74a7ed-817d-4049-a4a9-c4381eb8de64/Myst+Studios-46-min.jpg?format=800w`,
];

export const PBAND_IMAGE = `${CDN}/046ebf47-30a9-4782-acd5-182a93213920/Myst+Yard+1-min.jpg?format=2000w`;

export const HERO_BG = `${CDN}/5fdf734c-2576-4dcb-b928-3268529f444d/Myst+Yard+3-min.jpg?format=2000w`;

export const HERO_VIDEO = "/media/myst-reel.mp4";
export const HERO_POSTER = "/media/myst-reel-poster.jpg";

export const STUDIO_PHOTOS = [
  { name: "Studio A", tag: "Tracking · Mix", url: "/media/studios/myst-studio-a-1.jpg" },
  { name: "Studio A", tag: "Control Room",  url: "/media/studios/myst-studio-a-2.jpg" },
  { name: "Studio D", tag: "Dolby Atmos",   url: "/media/studios/myst-studio-d-atmos-1.jpg" },
  { name: "Studio D", tag: "Atmos Suite",   url: "/media/studios/myst-studio-d-atmos-2.jpg" },
  { name: "Studio F", tag: "Writing Room",  url: "/media/studios/myst-studio-f.jpg" },
];

export const HERO_STACK = [
  `${CDN}/87a19a28-14d8-4cec-892c-cf465b0f0768/Myst+Studios-44-min.jpg?format=1200w`,
  `${CDN}/046ebf47-30a9-4782-acd5-182a93213920/Myst+Yard+1-min.jpg?format=1200w`,
  `${CDN}/9b5a6c92-c988-4955-bad4-6ac0472d7af2/Myst+Bar+1-min.jpg?format=1000w`,
];

export const MOSAIC = [
  { caption: "Studio A", cls: "m-large", url: `${CDN}/87a19a28-14d8-4cec-892c-cf465b0f0768/Myst+Studios-44-min.jpg?format=1500w` },
  { caption: "Control room", cls: "", url: `${CDN}/786bd8ec-5d29-4a59-a30c-28006d8dbeb1/Myst+Studio+A+2-min.jpg?format=1000w` },
  { caption: "Live room", cls: "", url: `${CDN}/2a7ea994-184e-4870-bf3d-0daa3f413485/Myst+Studios-25-min.jpg?format=1200w` },
  { caption: "Session ready", cls: "", url: `${CDN}/80ddca6f-f2c3-4264-b35c-35a1e177ba4e/Myst+Studios-16-min.jpg?format=1000w` },
  { caption: "Writing room", cls: "m-wide", url: `${CDN}/1c9ce555-73c5-4b10-83d4-642c7d1e9b4a/Myst+Studios-43-min.jpg?format=1200w` },
  { caption: "Tracking", cls: "", url: `${CDN}/55dfeddf-ad89-448d-b795-6982d288d89b/Myst+Studios-27-min.jpg?format=1000w` },
  { caption: "Mix desk", cls: "", url: `${CDN}/303c9f37-b403-4f78-8242-09841666f648/Myst+Studios-18-min.jpg?format=1000w` },
  { caption: "Vocal booth", cls: "", url: `${CDN}/451a661b-0bd7-40d2-81e2-96cfed6827fd/Myst+Studios-15-min.jpg?format=1000w` },
  { caption: "Production suite", cls: "", url: `${CDN}/99ed1fcc-a7ba-473f-918a-111fc9ed74fc/Myst+Studios-42-min.jpg?format=1000w` },
  { caption: "Suite B", cls: "m-wide", url: `${CDN}/ced6b079-9da8-4ae3-a331-0a0d89aed9e4/Myst+Studios-13-min.jpg?format=1200w` },
  { caption: "Mix room", cls: "", url: `${CDN}/bb74a7ed-817d-4049-a4a9-c4381eb8de64/Myst+Studios-46-min.jpg?format=1000w` },
];

export const STICKERS = [
  { text: "\uD83C\uDF99 Red light on", cls: "sticker-1" },
  { text: "\uD83C\uDF3F Courtyard vibes", cls: "sticker-2" },
  { text: "\uD83E\uDD42 Bar open late", cls: "sticker-3" },
  { text: "\uD83C\uDFAC Shoot-ready", cls: "sticker-4" },
  { text: "\uD83D\uDCBF Sync too, btw", cls: "sticker-5" },
];

export const ARTIST_HERO = "https://image.static.bstage.in/cdn-cgi/image/metadata=none/bmfdemo-17/47bb2f26-9114-449c-88c5-c8cfdbfb9850/3d19ad0a-348e-4be6-a35a-d13748ec58f2/ori.jpg";

export const ARTIST_CARDS = [
  {
    name: "Jacqueline Fernandez",
    note: "Performance · catalog · collaboration",
    url: "https://image.static.bstage.in/cdn-cgi/image/metadata=none/bmfdemo-17/74b857c7-33f3-4d2b-9f93-52be4289d124/8d8a05a6-1b6c-4a6a-a42a-bbba377d22df/ori.jpg",
  },
  {
    name: "Myst Music roster",
    note: "Global voices · one-stop sync clearance",
    url: "https://image.static.bstage.in/cdn-cgi/image/metadata=none/mystmusic/7ae3064d-40be-4d84-b577-92143f8db4b4/3e8576ea-8b44-4ea5-b308-2c3826dcf3b1/ori.jpeg",
  },
];

export const SPACES = [
  { tag: "Studio", title: "The Studios", body: "Write it. Track it. Mix it. Multiple rooms, real acoustics, California light through every window.", url: `${CDN}/87a19a28-14d8-4cec-892c-cf465b0f0768/Myst+Studios-44-min.jpg?format=1200w` },
  { tag: "Outside", title: "The Courtyard", body: "String lights, stone paths. Listening parties, launches and ceremonies under open sky.", url: `${CDN}/046ebf47-30a9-4782-acd5-182a93213920/Myst+Yard+1-min.jpg?format=1200w` },
  { tag: "Bar", title: "The Bar", body: "After the session, before the after-party — where the night starts and deals get made.", url: `${CDN}/9b5a6c92-c988-4955-bad4-6ac0472d7af2/Myst+Bar+1-min.jpg?format=1200w` },
  { tag: "Villa", title: "The Villa", body: "Full-building takeover for weddings, milestones and productions. Indoor-outdoor flow.", url: `${CDN}/5fdf734c-2576-4dcb-b928-3268529f444d/Myst+Yard+3-min.jpg?format=1200w` },
  { tag: "Kitchen", title: "The Kitchen", body: "Catering-ready and outside F&B welcome. Feed the crew something better than pizza.", url: `${CDN}/85af4ba3-4b0d-4a1c-a8d4-64cd3419d10a/Myst+Kitchen-min.jpg?format=1200w` },
];

export const WALL = [
  { cls: "w1", url: `${CDN}/2a7ea994-184e-4870-bf3d-0daa3f413485/Myst+Studios-25-min.jpg?format=1200w` },
  { cls: "w2", url: `${CDN}/8cf985cc-d206-4b62-8bbf-9c7e3ca843ab/Myst+Bar+2-min.jpg?format=800w` },
  { cls: "w3", url: `${CDN}/c1adc7a4-a628-4a2e-afc2-22a3ece816c1/Myst+Yard+2-min.jpg?format=1200w` },
  { cls: "w4", url: `${CDN}/786bd8ec-5d29-4a59-a30c-28006d8dbeb1/Myst+Studio+A+2-min.jpg?format=800w` },
  { cls: "w5", url: `${CDN}/1c9ce555-73c5-4b10-83d4-642c7d1e9b4a/Myst+Studios-43-min.jpg?format=1000w` },
  { cls: "w6", url: `${CDN}/8c1b6cf2-03ca-4508-aa3d-1bb9b8ef2379/Highgate+2-min.jpg?format=1000w` },
];

export const EVENTS = [
  { title: "Listening parties", note: "New album. Courtyard setup. Bar open. Artist in the room." },
  { title: "Recording sessions", note: "Day rates and week blocks — actually good rooms." },
  { title: "Weddings & celebrations", note: "Tuscan elegance in West LA, without flying to Italy." },
  { title: "Film & brand shoots", note: "Multiple looks. One address. Production-ready." },
  { title: "Industry nights", note: "Sync people, producers, artists — the bar IS the meeting." },
  { title: "Private blowouts", note: "Milestone birthdays. Label anniversaries. You know." },
];

export const SYNC_IMAGE = `${CDN}/c59a2536-a906-4082-95e2-2ec0a2c31e12/Highgate+Upstairs+2-min.jpg?format=1200w`;

export const TICKER_A = [
  "Recording studios", "Listening parties", "The courtyard", "Bar inside",
  "Weddings", "Film shoots", "Industry nights", "Studio A", "Highgate upstairs",
];
export const TICKER_B = [
  "Yes the bar stays open", "Yes you can get married here", "Yes we have a courtyard",
  "Yes it's actually gorgeous", "Yes there's sync licensing too",
];
